import Image from 'next/image';

import { Box, Card, Heading, Paragraph } from '@zillow/constellation-10';

import enhanceVisibility from '../../assets/enhance-visibility.svg';
import getSeriousLeads from '../../assets/get-serious-leads.svg';
import manageSeamlessly from '../../assets/manage-seamlessly.svg';
import stayFutureReady from '../../assets/stay-future-ready.svg';

const cardsConfig = [
  {
    image: enhanceVisibility,
    title: 'Enhance visibility',
    description: 'Easily turn unadvertised properties into rich media listings on Zillow and HotPads',
  },
  {
    image: manageSeamlessly,
    title: 'Manage seamlessly',
    description: 'Once claimed, listings stay accurate and hassle-free thanks to feed-enabled updates',
  },
  {
    image: getSeriousLeads,
    title: 'Get serious leads',
    description: 'Receive HotPads leads right in your inbox from renters searching for your properties',
  },
  {
    image: stayFutureReady,
    title: 'Stay future-ready',
    description: 'Get your properties ready for up to 20x more exposure* powered by flexible ad options',
  },
];

export const ClaimYourListingDetails = ({ isFromModal = false }: { isFromModal?: boolean }) => (
  <>
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: {
          base: 'repeat(2, minmax(0, 1fr))',
          xl: isFromModal ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))',
        },
        gridAutoRows: '1fr',
        gap: '400',
      }}
    >
      {cardsConfig.map((card) => (
        <Card tone="neutral" key={card.title} css={{ padding: '600' }}>
          <Image src={card.image} alt={card.title} width={128} height={128} />
          <Heading
            textStyle="heading-sm"
            level={6}
            css={{
              overflowWrap: 'break-word',
              marginBlock: '400',
            }}
          >
            {card.title}
          </Heading>
          <Paragraph
            textStyle="body"
            css={{
              overflowWrap: 'break-word',
            }}
          >
            {card.description}
          </Paragraph>
        </Card>
      ))}
    </Box>
    <Paragraph textStyle="body-xs" css={{ marginTop: 'md', fontStyle: 'italic' }}>
      *Zillow Internal Data. Multifamily claimed listing performance. Total Impressions. May-June 2025.
    </Paragraph>
  </>
);

export default ClaimYourListingDetails;
